/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zalo_Oauth_State_InvalidInputs */

const vi_error_zalo_oauth_state_invalid = /** @type {(inputs: Error_Zalo_Oauth_State_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên kết nối đã hết hạn, đã dùng hoặc do tài khoản khác bắt đầu. Bấm Kết nối lại.`)
};

/**

* @param {Error_Zalo_Oauth_State_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_oauth_state_invalid = /** @type {((inputs?: Error_Zalo_Oauth_State_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Oauth_State_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_oauth_state_invalid(inputs)
});